import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment'
import { AuthService } from "src/app/core/service/auth.service";

@Injectable({
  providedIn: 'root'
})

export class ResultadosService {

  datos;
  expID;
  private URL = environment.apiUrl;



  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
  ) { }

  getEstudio(): Observable<any> {
    this.datos = { PacID: parseInt(this.authService.currentUserValue.PacienteID, 10), FecPac: sessionStorage.getItem('Fecha') };
    return this.http.post<any>(this.URL + '/traeestudios', this.datos);
  }

  getEstudioFecha(fecha: string): Observable<any> {
    this.datos = { ExpID: this.authService.currentUserValue.IDExp, FecPac: fecha };
    return this.http.post<any>(this.URL + '/traeestudios', this.datos);
  }

  getFechas(): Observable<any> {
    this.expID = this.authService.currentUserValue.IDExp;
    return this.http.get<any>(this.URL + '/traefechas/' + this.expID);
  }

  getResultados(pacID: string, estID: string): Observable<any> {
    this.datos = { PacID: parseInt((pacID), 10), EstID: estID };
    return this.http.post<any>(this.URL + '/traeresultados', this.datos);
  }

  traeNombreEstudio(EstID: string): Observable<any> {
    return this.http.get<any>(this.URL + '/nombreestudio/' + EstID);
  }

  DespliegaResultados(pacID: string, estID: string): Observable<any> {
    this.datos = { pacID: parseInt((pacID), 10), estID };
    return this.http.post<any>(this.URL + '/despliegaresultados', this.datos);
  }

  DespliegaEstudios(pacID: string): Observable<any> {
    this.datos = { PacID: parseInt((pacID), 10) };
    return this.http.get<any>(this.URL + '/despliegaestudios/' + pacID);
  }

  TieneTabla(EstID: string, CompID: string): Observable<any> {
    this.datos = { EstID: EstID, CompID:CompID };
    return this.http.post<any>(this.URL + '/tienetabla', this.datos);
  }

  DespliegaResultadosTexto(pacID: string, estID: string): Observable<any> {
    this.datos = { pacID: parseInt((pacID), 10), estID };
    return this.http.post<any>(this.URL + '/despliegaresultadostexto', this.datos);
  }

  DespliegaEstudiosTexto(pacID: string): Observable<any> {
    this.datos = { PacID: parseInt((pacID), 10) };
    return this.http.get<any>(this.URL + '/despliegaestudiostexto/' + pacID);
  }

  DespliegaResultadosRX(pacID: string, estID: string): Observable<any> {
    this.datos = { pacID: parseInt((pacID), 10), estID };
    return this.http.post<any>(this.URL + '/despliegaresultadosrx', this.datos);
  }

  DespliegaEstudiosRX(pacID: string): Observable<any> {
    this.datos = { PacID: parseInt((pacID), 10) };
    return this.http.get<any>(this.URL + '/despliegaestudiosrx/' + pacID);
  }

  /** Endpoint consolidado: devuelve laboratorio + texto + rayosX listos para desplegar */
  GetResultadosPaciente(pacID: string): Observable<any> {
    return this.http.get<any>(this.URL + '/resultadospaciente/' + pacID);
  }
}

